import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {ReasonCodeSearchModel} from "../reason-code-search.model";
import {ReasonCodeEntityModel} from "../reason-code-entity.model";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";
import {FUIAlertService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-reason-code-search-page",
    templateUrl: "./reason-code-search-page.component.html",
    providers: [provideSearchModel(ReasonCodeSearchModel), provideEntityModel(ReasonCodeEntityModel)]
})
export class ReasonCodeSearchPageComponent extends AbstractSearchPage {
    constructor(private searchModel: ReasonCodeSearchModel) {
        super();
    }
}
